
import Vue from "vue";
import AppColorPicker from "@/components/ColorPicker.vue";
import { Highlight } from "@/utils/sale-edit/sale-edit-highlight";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>Highlight,
			required: true
		}
	},
	components: {
		AppColorPicker
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
